import { Box, Button, Card, CardActions, CardContent, TextField, Typography, useTheme } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { useState } from "react";
import { GET_OTP, VERIFY_OTP } from "../../redux/apis";

import { useDispatch } from "react-redux";
import { getLoggedInUser } from "../../utilities/authUtils";
import "./loginComponent.css";
import CommonAlert from "../alert/CommonAlert";
import { makeStyles } from "@mui/styles";
import { Loader } from "../loader/loader";

const useStyles = makeStyles((theme: any) => ({
    loginBox: {
        width: '80%',
        [theme.breakpoints.down("md")]: {
            width: '100%'
        },
        [theme.breakpoints.up("md")]: {
            width: '60%'
        },
        [theme.breakpoints.up("lg")]: {
            width: '60%'
        }
    },

}));

export const LoginComponent: React.FC<any> = ({ isRedirect, handleSubmit }) => {
    const [mobileNumber, setMobileNumber] = useState("");
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [showOtpMsg, setShowOtpMsg] = useState(false);
    const [otp, setOtp] = useState("");
    const [name, setName] = useState("");
    const history = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [otpError, setOtpError] = useState(false);

    // const theme = useTheme();

    // const matches = useMediaQuery(theme.breakpoints.up("sm"));
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        setIsLoading(false);
    }

    const handleSendOtp = async () => {
        if (!isLoading) { setIsLoading(true); }
        const response = await fetch(`${GET_OTP}/${mobileNumber}`)
            .then((response) => response.json())
            .then((data: any) => {
                setIsLoading(false);
                if (data.Status == 'SUCCESS') {
                    setIsOtpSent(true);
                    setShowOtpMsg(true);
                    setOtp(data.otpCode);
                    setTimeout(() => {
                        setShowOtpMsg(false);
                    }, 2000);
                }
            })
            .catch((error) => { setIsLoading(false); console.error(error) });
    };

    const handleMobileNumberChange = (e) => {
        const newValue = e.target.value;
        // Allow only digits and limit input to 6 characters
        if (/^\d{0,10}$/.test(newValue)) {
            setMobileNumber(newValue);
        }
    };

    const handleOtpChange = (e) => {
        setError('');
        const newValue = e.target.value;
        // Allow only digits and limit input to 4 characters
        if (/^\d{0,4}$/.test(newValue)) {
            setOtp(newValue);
        }
    };

    const getLogin = async () => {
        if (!isLoading) { setIsLoading(true); }
        const response = await fetch(`${VERIFY_OTP}/${mobileNumber}/${otp}`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 401) {
                    setIsLoading(false);
                    throw new Error('OTP is incorrect');
                } else {
                    setIsLoading(false);
                    throw new Error('An error occurred');
                }
            })
            .then((data) => {
                if (data && data.token) {
                    localStorage.setItem("token", data.token);
                    setIsLoading(false);
                    if (!isRedirect) {
                        handleSubmit();
                    }
                    getLoggedInUser(isRedirect, dispatch, history);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
                // Display error message
                setError('OTP is incorrect');
                // Change OTP text box border color to red
                setOtpError(true);
            }).finally(() => {
                setIsLoading(false);
            });
    };

    return <>
        <Loader loading={isLoading} handleClose={handleClose} />
        <Box
            mb={4}
            mt={4}
            // display="flex"
            // flexDirection="column"
            // alignItems="center"
            p={5}
            // bgcolor="#fff"
            // borderRadius={2}
            // boxShadow={3}
            // width="60%"
            className={classes.loginBox}
        // height={'60vh'}
        // minWidth="400px"
        >
            <Card sx={{ width: '100%', pb: 4 }}>

                <CardContent sx={{ textAlign: 'center', p: 6 }}>
                    <Box mb={2}>
                        <img
                            src={require('../../../assets/Home/niruval.png')}
                            alt="OTP Verification"
                            style={{ width: '250px', height: 'auto' }}
                        />
                    </Box>
                    <Typography variant="h6" mb={2}>
                        <strong> LOGIN </strong>
                    </Typography>

                    <TextField
                        label="Enter your Mobile Number"
                        size="medium"
                        variant="outlined"
                        margin="normal"
                        sx={{ width: '80%' }}
                        value={mobileNumber}
                        slotProps={{
                            input: {
                                inputMode: 'numeric',
                            },
                        }}
                        onChange={handleMobileNumberChange}
                    />
                    <CardActions sx={{ textAlign: 'center', justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ width: '82%', backgroundColor: '#0f456c', color: '#fff' }}
                            size="small"
                            onClick={handleSendOtp}
                        >
                            Send OTP
                        </Button>
                    </CardActions>
                    <TextField
                        label="Enter OTP"
                        variant="outlined"
                        disabled={!isOtpSent}
                        sx={{
                            width: '80%'
                        }}
                        margin="normal"
                        value={otp}
                        slotProps={{
                            input: {
                                inputMode: 'numeric',
                            },
                        }}
                        onChange={handleOtpChange}
                    />
                    {error && <Typography variant="h5" color="error">{error}</Typography>}
                    <CardActions sx={{ justifyContent: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{ width: '82%', backgroundColor: '#0f456c', color: '#fff' }}
                            sx={{ mt: 1, mb: 1 }}
                            disabled={!isOtpSent}
                            onClick={getLogin}
                        >
                            LOGIN
                        </Button>
                    </CardActions>
                    {/* <FormControlLabel
                    control={<Checkbox />}
                    label="You'll be able to save your details to create an account later."
                    sx={{ alignSelf: "flex-start", mb: 1 }}
                />
                <FormControlLabel
                    control={<Checkbox />}
                    label="Keep me up to date on exclusive offers"
                    sx={{ alignSelf: "flex-start", mb: 2 }}
                /> */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignContent: "center",
                            width: "auto",
                        }}
                    >
                        <Typography variant="body2" color="textSecondary">
                            Don't have an account yet?{" "}
                            <Link
                                to="/otpverification"
                                color="primary"
                                style={{ marginLeft: "5px" }}
                            >
                                <strong>Register Free</strong>
                            </Link>
                        </Typography>
                    </Box>
                    {showOtpMsg && <CommonAlert message="OTP sent to your mobile number." variant="filled" severity="success" onClose={() => { setShowOtpMsg(false) }} />}
                </CardContent>
            </Card>
        </Box >
    </>
};
